import Skill from "./Skill";
import { ISkillItem, ISkillItemEndpoints } from "../../../types";

export default class SkillItem implements ISkillItem {
  readonly id: number
  public name: string
  public criteria: string
  readonly skill: Skill
  readonly endpoints: ISkillItemEndpoints

  constructor (endpoints: ISkillItemEndpoints, id: number, name: string, skill: Skill) {
    this.id = id
    this.name = name
    this.skill = skill
    this.endpoints = endpoints
  }

  public get toParams() {
    return { id: this.id, name: this.name, skill_id: this.skill.id }
  }
}
